export default "__VITE_ASSET__DntjCbD7__"